import * as swcHelpers from '@swc/helpers';
import { DataLayer } from '@grandvisionhq/analytics';
import { mapProductToDataLayerProductObject } from '../Mappers/ProductMapper.js';

const createImpressionEvent = (currency)=>{
    return {
        event: 'gvProductImpressions',
        atfEcommerce: {
            ecommerce: {
                currencyCode: currency,
                impressions: []
            }
        }
    };
};
const createImpressionObject = (product, position)=>{
    var ref;
    return swcHelpers.objectSpread({}, mapProductToDataLayerProductObject(DataLayer.DataLayerTypes.PurchaseType.OneTime, product, product.masterVariant.sku || 'undefined'), {
        list: `category: ${(ref = product.productType.obj) === null || ref === void 0 ? void 0 : ref.name}`,
        position
    });
};

export { createImpressionEvent, createImpressionObject };
//# sourceMappingURL=ProductListingPageEvents.js.map
